<template>
    <div class="grid-content" v-loading="isLoading">
        <div v-if="!readonly" class="loading">
            <el-button size="medium" type="primary" plain icon="el-icon-plus" @click="addType">添加业务</el-button>
        </div>
        <div class="price-area" v-for="item in trainingCategoryList" :key="item.Guid" :name="item.Name">
            <trainingType ref="trainingType" :readonly="readonly" :courseType="courseType" :campusList="campusList" :trainingCategory="item" @remove="onRemoveCategory" @saveCategoryName="onSaveCategoryName"></trainingType>
        </div>
        <el-row v-if="!readonly" class="cs-filter-row">
            <el-col :span="4" class="footer-left">
                <el-button size="medium" :disabled="submitBtnDisable" :type="submitBtnClass" @click="saveChanges">保存更新</el-button>
            </el-col>
            <el-col :span="16" class="footer-right">
                <el-alert :closable="false" v-show="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
            </el-col>
        </el-row>
    </div>
</template>

<style lang="scss" scoped>
.price-area {
    margin-top: 30px;
    margin-left: 20px;
}
</style>

<script>
import trainingType from '../priceManagement/trainingType'
import {
    guid
} from "../../config/mUtils.js"
import {
    saveTrainingCategory,
    getTrainingPrices,
    saveTrainingPrices,
    saveEnglishTrainingPrices,
    saveNewStudentGuidePrices,
} from "../../service/globalPriceSetting.service.js"
import { getCampusList } from "../../service/common.service";

export default {
    props: {
        isActive: Boolean,
        readonly: Boolean,
        courseType: Number
    },
    data() {
        return {
            isLoading: false,
            isLoadedData: false,
            trainingCategoryList: [],
            showError: false,
            submitBtnClass: "primary",
            errorMessage: "",
            submitBtnDisable: false,
            campusList: [],
            isCampusLoaded: false,
        };
    },
    components: {
        trainingType
    },
    created() {
        this.init();
    },
    methods: {
        init(){
            if (!this.isActive){
                return;
            }
            this.isLoading = true;
            this.isCampusLoaded = false;
            this.isLoadedData = false;
            this.loadCampusList();
            this.loadTrainingPrice();
        },
        loadCampusList() {
            getCampusList().then(result => {
                if (!!result && result.success) {
                    this.campusList = result.data;
                }
                this.isCampusLoaded = true;
                this.checkLoading();
            });
        },
        loadTrainingPrice() {
            getTrainingPrices(this.courseType).then(result => {
                if (result && result.success) {
                    this.trainingCategoryList = result.data;
                }
                this.isLoadedData = true;
                this.checkLoading();
            });
        },
        checkLoading(){
            if (this.isCampusLoaded && this.isLoadedData){
                this.isLoading = false;
            }
        },
        addType() {
            let newCategory = this.newTrainingCategory();
            this.trainingCategoryList.push(newCategory);
        },
        saveChanges() {
            let isValid = true;
            
            if (!!this.$refs.trainingType) {
                this.$refs.trainingType.forEach(element => {
                    isValid = element.validatePrice();
                });
            }

            if (!isValid)
                return;
            this.isLoading = true;
            if (!!this.$refs.trainingType) {
                let dataModel = [];
                this.$refs.trainingType.forEach(element => {
                    let categoryModel = element.getDataModel();
                    dataModel.push(categoryModel);
                });
                
                if (dataModel.length > 0) {
                    switch (this.courseType) {
                        case this.GLOBAL.courseType.english:
                            saveEnglishTrainingPrices(dataModel).then(result => {
                                if (result && result.success) {
                                    this.$message({
                                        message: '课程价格信息保存成功',
                                        type: 'success'
                                    });
                                    this.loadTrainingPrice();
                                } else {
                                    this.$message.error(result.message);
                                }
                                this.isLoading = false;
                            });
                            break;
                        case this.GLOBAL.courseType.newStudentGuide:
                            saveNewStudentGuidePrices(dataModel).then(result => {
                                if (result && result.success) {
                                    this.$message({
                                        message: '课程价格信息保存成功',
                                        type: 'success'
                                    });
                                    this.loadTrainingPrice();
                                } else {
                                    this.$message.error(result.message);
                                }
                                this.isLoading = false;
                            });
                            break;
                        default:
                            saveTrainingPrices(dataModel).then(result => {
                                if (result && result.success) {
                                    this.$message({
                                        message: '课程价格信息保存成功',
                                        type: 'success'
                                    });
                                    this.loadTrainingPrice();
                                } else {
                                    this.$message.error(result.message);
                                }
                                this.isLoading = false;
                            });
                            break;
                    }
                }
            }
        },
        onSaveCategoryName(cateogryModel) {
            saveTrainingCategory(cateogryModel).then(result => {
                if (result && result.success) {
                    let category = this.trainingCategoryList.filter(p => p.Guid == cateogryModel.Guid)[0];
                    category.Name = cateogryModel.Name;
                    category.Id = result.data;
                }
            })
        },
        onRemoveCategory(cateogryModel){
            if (!!cateogryModel && !!cateogryModel.Guid){
                let index = this.trainingCategoryList.findIndex(i => i.Guid == cateogryModel.Guid);
                this.trainingCategoryList.splice(index, 1);
            }
        },
        newTrainingCategory() {
            let category = {
                Guid: guid(),
                Id: 0,
                Name: '',
                CourseType: this.courseType,
                TrainingPrices: []
            }
            return category;
        },
    },
    watch: {
        isActive: function () {
            if (this.isActive && !this.isLoadedData) {
                this.init();
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/trainingPrice.vue